<template>
  <div
    class="ads-banner__container"
    :class="{ 'ads-banner-vertical': isVertical() }"
  >
    <div class="info-block">
      <span v-if="description">
        {{ description }}
      </span>
      <div class="button" @click="openUrl">
        {{ buttonName }}
      </div>
    </div>
    <img :src="thumbnailUrl" :alt="title" />
  </div>
</template>

<script>
export default {
  name: 'AdsBanner',
  props: {
    title: {
      required: true,
      default: '',
      type: String,
    },
    description: {
      required: false,
      default: '',
      type: String,
    },
    buttonName: {
      required: true,
      default: '',
      type: String,
    },
    buttonLink: {
      required: true,
      default: '',
      type: String,
    },
    thumbnailUrl: {
      required: true,
      default: '',
      type: String,
    },
    type: {
      required: true,
      default: 'horizontal',
      type: String,
    },
  },
  methods: {
    openUrl() {
      window.open(this.buttonLink, '_self')
    },
    isVertical() {
      return this.type !== 'horizontal'
    },
  },
}
</script>

<style scoped lang="scss">
.view-only .ql-editor .ads-banner__container img {
  width: 224px !important;
  height: 124px !important;

  @media (max-width: 575.98px) {
    width: 100% !important;
    height: auto !important;
  }
}

.view-only .ql-editor .ads-banner-vertical img {
  width: 100% !important;
  height: auto !important;
}

.ads-banner__container {
  display: flex;
  gap: 16px;
  padding: 24px;
  border-radius: 8px;
  background: #f9f9f9;
  max-width: 736px;
  width: 100%;
  @media (max-width: 575.98px) {
    width: 100%;
    max-width: none !important;
    flex-direction: column !important;
  }

  .info-block {
    display: flex;
    flex-direction: column;
    @media (max-width: 575.98px) {
      width: 100%;
      max-width: none !important;
      order: 2 !important;
    }

    span {
      color: #323232;
      font-family: 'DM Sans', serif;
      font-size: 16px;
      font-style: normal;
      font-weight: 400;
      line-height: 20px;
    }

    .button {
      cursor: pointer;
      margin-top: 16px;
      height: 48px;
      padding: 9px 24px;
      align-self: flex-start;
      border-radius: 8px 0;
      background: #444050;
      box-shadow: 0 1px 10px 0 rgba(29, 32, 35, 0.15);
      color: #fff;
      text-align: center;
      font-family: 'DM Sans', serif;
      font-size: 18px;
      font-style: normal;
      font-weight: 500;
      line-height: 26px;
      width: auto;
      white-space: nowrap;
      max-width: 295px;

      @media (max-width: 575.98px) {
        width: 100%;
        max-width: none !important;
      }
    }
  }

  img {
    order: 2;
    width: 224px;
    height: 124px;
    border-radius: 8px;

    @media (max-width: 575.98px) {
      width: 100% !important;
      height: auto !important;

      order: 1 !important;
    }
  }
}

.ads-banner-vertical {
  flex-direction: column;
  max-width: 355px;

  .info-block {
    order: 2;

    span {
      max-width: 295px;
    }

    .button {
      width: 100%;
    }
  }

  img {
    order: 1;
    width: 100%;
    height: auto;
  }
}
</style>
